'use client';

var BREAKPOINTS = {
    xs: 0,
    sm: 769,
    md: 1025,
    lg: 1301,
    xl: 1441,
    vnw: 1141
};
var CONTAINER = {
    xs: 0,
    sm: 768,
    md: 1024,
    lg: 1300,
    xl: 1440,
    vnw: 1140,
    full: '100%'
};
var MAXIMUM_COL = 24;
var alignValues = {
    top: 'start',
    middle: 'center',
    bottom: 'end'
};

export { BREAKPOINTS, CONTAINER, MAXIMUM_COL, alignValues };
//# sourceMappingURL=constants.js.map
